module.exports = __webpack_public_path__ + "static/media/404.cb54390b.svg";